// extracted by css-extract-rspack-plugin
export default {"moveInSection":"DatePickerDropdown-module__moveInSection"};